import { ZERO_WEI } from '@kwenta/sdk/constants'
import type { Prices } from '@kwenta/sdk/types'
import { getDisplayAsset } from '@kwenta/sdk/utils'
import { wei } from '@kwenta/wei'
import { createSelector } from '@reduxjs/toolkit'

import type { RootState } from 'state/store'

export const selectPrices = createSelector(
	(state: RootState) => state.prices,
	({ onChainPrices, offChainPrices }) => {
		const merged: Prices = {}
		Object.entries(onChainPrices).forEach(([key, { price }]) => {
			merged[key] = {
				onChain: wei(price),
			}
		})
		Object.entries(offChainPrices).forEach(([key, { price }]) => {
			if (merged[key]) {
				merged[key].offChain = wei(price)
			} else {
				merged[key] = {
					offChain: wei(price),
				}
			}
		})
		return merged
	}
)

export const selectOffchainPricesInfo = (state: RootState) => state.prices.offChainPrices

export const selectPreviousDayPrices = (state: RootState) => state.prices.previousDayPrices

export const selectPricesConnectionError = (state: RootState) => state.prices.connectionError

export const select24hrPriceChanges = createSelector(
	selectPrices,
	selectPreviousDayPrices,
	(prices, pastPrices) => {
		return Object.keys(prices).reduce<Record<string, number>>((acc, asset) => {
			const price = prices[asset]?.offChain
			const pastPrice = pastPrices.find(
				(price) => price.synth === getDisplayAsset(asset)?.toUpperCase()
			)

			const change =
				price && pastPrice?.rate && wei(price).gt(0)
					? wei(price).sub(pastPrice.rate).div(pastPrice.rate)
					: ZERO_WEI

			acc[asset] = change.toNumber()
			return acc
		}, {})
	}
)
